import api from "./client";
import type { ApiResponse, BaseFilterParams, Paginated } from "#/types/api";
import type { PrvPatternsView, PrvResetResult, PrvRun } from "#/types/prv";

/**
 * PRV Engine, TMA admin only. Config (schedule, radius, min dwell) is edited
 * through `clientsApi.update` — it lives on the client record.
 */
export const prvApi = {
  listRuns: (
    clientId: number,
    params: BaseFilterParams
  ): Promise<ApiResponse<Paginated<PrvRun[]>>> =>
    api.get(`/prv/clients/${clientId}/runs`, { params }),

  /** Starts a manual run; the run continues server-side. Poll `getRun`. */
  startRun: (clientId: number): Promise<ApiResponse<PrvRun>> =>
    api.post(`/prv/clients/${clientId}/runs`, {}),

  getActiveRun: (clientId: number): Promise<ApiResponse<{ run: PrvRun | null }>> =>
    api.get(`/prv/clients/${clientId}/runs/active`),

  getRun: (clientId: number, runId: number): Promise<ApiResponse<PrvRun>> =>
    api.get(`/prv/clients/${clientId}/runs/${runId}`),

  getPatterns: (clientId: number): Promise<ApiResponse<PrvPatternsView>> =>
    api.get(`/prv/clients/${clientId}/patterns`),

  /** Read-only, for client users: the patterns of one of their own sub-clients. */
  getSubClientPatterns: (subClientId: number): Promise<ApiResponse<PrvPatternsView>> =>
    api.get(`/prv/sub-clients/${subClientId}/patterns`),

  /** Clean slate: runs, checkpoints, patterns. Config and targets are kept. 409 while a run is in progress. */
  resetData: (clientId: number): Promise<ApiResponse<PrvResetResult>> =>
    api.delete(`/prv/clients/${clientId}/data`),
};
